export default {
  address: 'Adres',
  contact: 'Contact',
  terms: 'Gebruiksvoorwaarden',
  privacy_policy: 'Privacybeleid',
  impressum: 'Impressum',
  cookie_policy: 'Cookiebeleid',
  cookie_settings: 'Cookie-instellingen',
};
